import { Injectable } from '@angular/core';
import { UnitService } from './unit.service';

@Injectable({
  providedIn: 'root'
})
export class RentalsService extends UnitService {
  protected _beforeLocalFilter(items: any[]): any[] {
    return items.filter((item) => item && item.rentalStatus != null);
  }
}
